import { useLocation } from 'react-router-dom';

export default function useUrlQuery() {
  const location = useLocation();

  return new URLSearchParams(location.search);
}
